export default {
  caseStudies: {
    page: {
      tagline: 'Success stories from customers',
      headline: 'Real results from',
      headlineHighlight: 'real delivery teams',
      description:
        'See how delivery and logistics teams — across restaurants, pharmacies, grocery, courier & parcel, e-commerce, and 3PL — use Geofleet to streamline last-mile operations, cut costs, and delight customers.',
    },
    featured: {
      label: 'Featured success story',
    },
    filters: {
      label: 'Filter by industry',
      allIndustries: 'All industries',
      ariaLabel: 'Filter case studies by industry',
    },
    list: {
      title: 'Customer stories',
      defaultSubtitle: 'Real challenges, real solutions, measurable outcomes across delivery teams',
      countInIndustry_one: '{{count}} story in this industry',
      countInIndustry_other: '{{count}} stories in this industry',
      story_one: '{{count}} story',
      story_other: '{{count}} stories',
    },
    empty: {
      title: 'No stories in this industry',
      hint: 'Try selecting a different industry filter.',
    },
    card: {
      readFullStory: 'Read full story',
    },
    explore: {
      badge: 'How to explore',
    },
    cta: {
      title: 'Ready to write your success story?',
      subtitle: 'Join delivery teams achieving similar results with Geofleet.',
    },
    detail: {
      schemaSection: 'Case Study',
      backLink: 'All case studies',
      challengeHeading: 'The challenge',
      solutionHeading: 'The solution',
      analytics: {
        metric: 'Metric',
        before: 'Before',
        after: 'After',
      },
      timelineTitle: 'Implementation timeline',
      keyTakeaways: 'Key takeaways',
      relatedTitle: 'Related case studies',
      exploreSolution: {
        badge: 'Explore the solution',
        title: 'See how Geofleet works for {{industry}}',
      },
      cta: {
        title: 'Get similar results',
        subtitle: 'See how Geofleet can help your team. Get started or book a tailored demo.',
      },
    },
  },
};
